// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"styles_closeButton__H1zZC","modal":"styles_modal__bwB8F"};